export default "__VITE_ASSET__DMnoe7EC__"